<button 
    class="square-button"
    [class.active]="isActive"
    (click)="handleClick()">
    @if(iconPath()){<img [src]="iconPath()" [alt]="label()" class="icon"> }
    <span class="label">{{ label() }}</span>
</button>